module.exports = __webpack_public_path__ + "static/img/Group@2x.e470bb7c.png";